import { TreeTableColumn } from '@app/types/pivot.types';

export const columnDefs: TreeTableColumn[] = [
  { id: 'description', label: 'Description' },
  { id: 'description', label: '# of Recs', width: '68px' },
  { id: 'description', label: 'Predicted Volume (CS)', width: '150px' },
];

export const roleMapping: { [key: string]: string[] } = {
  ['NextBestSKU.FSOPUser']: ['FSOP'],
  ['NextBestSKU.CRUser']: ['CR'],
  ['NextBestSKU.Admin']: ['ADMIN'],
};
